import gql from "graphql-tag";

export const GET_MANAGER_EMPLOYEE_LIST = gql`
query getManagerEmployeeList {
  allEmpoloyee: me {
    id
    employee {
      id
      orgCeoEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      orgPocEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      teamManagerEmployee {
        edges {
          node {
            id
            vertical {
              id
              heads(user_Status_Verified: true) {
                edges {
                  node {
                    id
                    user {
                      id
                      firstName
                      lastName
                      email
                      employee {
                        id
                      }
                    }
                  }
                }
              }
            }
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      verticalHeadEmployee {
        edges {
          node {
            id
            parentvertical {
              heads(user_Status_Verified: true) {
                edges {
                  node {
                    id
                    user {
                      id
                      firstName
                      lastName
                      email
                      employee {
                        id
                      }
                    }
                  }
                }
              }
            }
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      teamMembersEmployee {
        edges {
          node {
            id
            managers(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      verticalMembersEmployee {
        edges {
          node {
            id
            heads(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`